/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Trigger = document.querySelectorAll(".trigger");
const fadein = document.querySelectorAll(".fadein");
const fadeinUp = document.querySelectorAll(".fadein-up");

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set(fadein, {
  opacity: 0,
});
gsap.set(fadeinUp, {
  yPercent: 20,
  opacity: 0,
});

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
  for (let i = 0; i < Trigger.length; i++) {
    gsap.to(Trigger[i].querySelectorAll(".fadein"), {
      opacity: 1,
      duration: 1,
      stagger: {
        from: "start",
        amount: 0.3,
      },
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
    });
    gsap.to(Trigger[i].querySelectorAll(".fadein-up"), {
      yPercent: 0,
      opacity: 1,
      duration: 1,
      stagger: {
        from: "start",
        amount: 0.3,
      },
      scrollTrigger: {
        trigger: Trigger[i],
        start: "top 75%",
        //   markers: true,
      },
    });
  };
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger };
